import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';

let _reportTypes = [];

let ReportTypeStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    getAll: function() {
        return _reportTypes.filter(function(e) { return e !== undefined; });
    },
    getById: function(id) {
        return _reportTypes.find(function(e) { return e !== undefined && e.id == id; });
    },
    add: function(reportType) {
        var index = _reportTypes.findIndex(function(e) { return e !== undefined && e.id == reportType.id;} );
        if (0 <= index) {
            _reportTypes[index] = reportType;
        } else {
            _reportTypes.push(reportType);
        }
    },
    remove: function(id) {
        var index = _reportTypes.findIndex(function(e) { return e !== undefined && e.id == id;} );
        if (0 <= index) {
            delete _reportTypes[index];
        }
    },

});

ReportTypeStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.REPORT_TYPE_LIST:
            action.data.forEach(ReportTypeStore.add);
            ReportTypeStore.emitChange();
            break;

        case ActionTypes.REPORT_TYPE_LIST_ERROR:
            ReportTypeStore.emitChange();
            break;

//        case ActionTypes.REPORT_TYPE_SAVE:
//            ReportTypeStore.add(action.data);
//            ReportTypeStore.emitChange();
//            break;
//
//        case ActionTypes.REPORT_TYPE_SAVE_ERROR:
//            ReportTypeStore.emitChange();
//            break;
//
//        case ActionTypes.REPORT_TYPE_INFO:
//            ReportTypeStore.add(action.data);
//            ReportTypeStore.emitChange();
//            break;
//
//        case ActionTypes.REPORT_TYPE_INFO_ERROR:
//            ReportTypeStore.emitChange();
//            break;
//
//        case ActionTypes.REPORT_TYPE_UPDATE:
//            ReportTypeStore.add(action.data);
//            ReportTypeStore.emitChange();
//            break;
//
//        case ActionTypes.REPORT_TYPE_UPDATE_ERROR:
//            ReportTypeStore.emitChange();
//            break;
//
//        case ActionTypes.REPORT_TYPE_DELETE:
//            if (!!action.data.deleted) {
//                ReportTypeStore.remove(action.data.id);
//            }
//            ReportTypeStore.emitChange();
//            break;
//
//        case ActionTypes.REPORT_TYPE_DELETE_ERROR:
//            ReportTypeStore.emitChange();
//            break;

        default:
            break;
    }

});

export default ReportTypeStore;
